import { render, staticRenderFns } from "./CenterViewTicketOrderConfirm_Ap.vue?vue&type=template&id=f6c1024a&scoped=true"
import script from "./CenterViewTicketOrderConfirm_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewTicketOrderConfirm_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewTicketOrderConfirm_Ap.vue?vue&type=style&index=0&id=f6c1024a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c1024a",
  null
  
)

export default component.exports